const podcasts_es = require('./podcasts.json')
export default podcasts_es